import { __assign } from "tslib";
import React from "react";
import classNames from "classnames";
var defaultProps = {
  label: "",
  helpText: "",
  name: "",
  placeholder: "",
  textareaProps: {},
  inputExtraClasses: "",
  required: false,
  invalid: false
};
export var TextareaField = function (partials) {
  var props = __assign(__assign({}, defaultProps), partials);

  var inputClassName = classNames("input-group", {
    "is-required": props.required
  }, props.inputExtraClasses);
  return React.createElement("div", {
    className: "form-group"
  }, props.label && React.createElement("label", {
    className: "form-input-label"
  }, props.label), React.createElement("div", {
    className: inputClassName
  }, React.createElement("textarea", __assign({
    name: props.name,
    className: "form-control",
    placeholder: props.placeholder
  }, props.textareaProps))), props.helpText && (typeof props.helpText === "string" ? React.createElement("small", {
    className: "form-text text-muted"
  }, props.helpText) : props.helpText));
};